import { Box, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { useParams } from "react-router-dom"
import { fetchPublicRoadmap, FetchRoadmapResponse, NewsQuery } from "../../../news/newsApi"
import { usePublicApiQuery } from "../../../../core/api/useApiQuery"
import { LoadingSpinner } from "../../../../shared/components/loading/LoadingSpinner"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { RoadmapContent } from "../../../news/components/RoadmapContent"

const useStyles = makeStyles()((theme) => ({
    root: {
        padding: "0 1rem",
    },
    error: {
        color: theme.palette.error.main,
        textAlign: "center",
        padding: theme.spacing(4),
    },
}))

const selectRoadmaps = (data: FetchRoadmapResponse) => data.roadmaps

export function PublicRoadmapPage() {
    const { classes } = useStyles()
    const { shareToken } = useParams<{ shareToken: string }>()

    const { data, isLoading, error } = usePublicApiQuery(fetchPublicRoadmap, {
        queryName: NewsQuery.PUBLIC_LIST,
        dependencies: { shareToken: shareToken ?? "" },
        enabled: Boolean(shareToken),
        select: selectRoadmaps,
    })

    if (isLoading) {
        return (
            <Box className={classes.root}>
                <LoadingSpinner />
            </Box>
        )
    }

    if (error) {
        return (
            <Box className={classes.root}>
                <LocalizedStrict id="news-new-load-error">
                    <Typography className={classes.error}>Error loading roadmap features</Typography>
                </LocalizedStrict>
            </Box>
        )
    }

    return <RoadmapContent items={data ?? []} isPublic />
}
